
<template>
  <div class="nav-copyright-wrapper">
    <ul class="project-nav">
      <li v-for="(project, index) in projects" :key="index" class="nav-item animated fadeInRight">
        <a
          @mouseenter="$eventBus.$emit('updateProject', project)"
          @click="$eventBus.$emit(footer?'updateFooterView':'updateProjectView', project)"
          :class="{'active':typeof parent.selectedProject!=='undefined'&&parent.selectedProject===project?'active':''}"
        >
          <span class="project-name" :style="{'--color':project.bgColor}">{{project.name}}</span>
          <span class="project-category">{{project.category}}</span>
        </a>
      </li>
    </ul>
    <div
      class="copyright animated"
      :class="{'fadeOut':parent.currentProjectView!==null && !footer }"
    >COPYRIGHT © {{parent.getYear()}} WILLIAM SOO - GRAPHIC DESIGNER</div>
  </div>
</template>

<script>
export default {
  name: "project-nav",
  props: ["projects", "footer", "parent"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.project-nav-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.copyright {
  position: absolute;
  bottom: 16px;
  font-size: 0.75rem;
  color: #888;
  padding-left: 13px;
}
.project-nav {
  list-style: none;
  padding: 0;
  color: #555;
}
.project-nav li a {
  display: flex;
  cursor: pointer;
  align-items: baseline;
  color: #949494;
}
.project-nav li a:hover .project-name,
.project-nav li a:focus .project-name,
.project-nav li a.active .project-name {
  color: var(--color);
}
.project-nav li a .project-name {
  position: relative;
  font-size: 1.5rem;
  position: relative;
  font-weight: 600;
  transition: 0.5s color ease-in-out;
  padding: 0.25rem;
}
.project-nav li a .project-category {
  text-transform: uppercase;
  font-size: 0.75rem;
  margin-left: 0.5rem;
}
.project-nav li a .project-name:after {
  content: "";
  background-color: var(--color);
  position: absolute;
  z-index: -1;
  bottom: 0.2em;
  left: -0.4em;
  right: -0.4em;
  height: 0.7em;
  opacity: 0.3;
  transform: scaleX(0);
  transform-origin: 0 50%;
  transition: transform 0.6s cubic-bezier(0.8, 0.03, 0.25, 1),
    -webkit-transform 0.6s cubic-bezier(0.8, 0.03, 0.25, 1);
}

.project-nav li a .project-name:hover:after,
.project-nav li a:hover .project-name:after,
.project-nav li a.active .project-name:after {
  transform: scaleX(1);
}

.nav-item {
  opacity: 0;
}
</style>
